import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConfiguration } from '@klubovna/api-client';
import { tagsControllerFindAll } from '@klubovna/api-client';
import { Tag } from '@klubovna/api-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TagsApiService {
  private http = inject(HttpClient);
  private apiConfig = inject(ApiConfiguration);

  findAll(): Observable<Tag[]> {
    return tagsControllerFindAll(this.http, this.apiConfig.rootUrl).pipe(map((response) => response.body as Tag[]));
  }
}

